import {USAGE_BEFORE_LOAD, USAGE_DATA, USAGE_NO_DATA, USAGE_NO_LOGIN} from "~/constants/empty";

export default {
    data() {
        return {
            loaded:false,
        }
    },
    computed: {
        // for pages where need load data asynchronously, no matter if login or not
        // empty case is also regular well
        // e.g. home,search view to show list view for both load/empty data, whatever login state
        isLoadDataEmpty() {
            return false
        },
        emptyLoadUsage() {
            if (!this.loaded) {
                return USAGE_BEFORE_LOAD
            }
            if (this.isLoadDataEmpty) {
                return USAGE_NO_DATA
            }
            return USAGE_DATA
        },
        hasLoadData() {
            return this.emptyLoadUsage == USAGE_DATA
        },


        // for pages where need login & show load data,
        // empty state is bad, prompt message should be shown
        // profiles/account etc, not for list view cases
        emptyLoginUsage() {
            if (!this.isLogin) {
                return USAGE_NO_LOGIN
            }
            return USAGE_DATA
        },
        hasLoginData() {
            return this.emptyLoginUsage == USAGE_DATA
        },

        // for pages where need login & load data asynchronously,
        // empty case is also regular well
        // e.g. login to show list view for both load/empty data
        isLoginLoadDataEmpty() {
            return false
        },
        emptyLoginLoadUsage() {
            if (!this.isLogin) {
                return USAGE_NO_LOGIN
            }
            if (!this.loaded) {
                return USAGE_BEFORE_LOAD
            }
            if (this.isLoginLoadDataEmpty) {
                return USAGE_NO_DATA
            }
            return USAGE_DATA
        },
        hasLoginLoadData() {
            return this.emptyLoginLoadUsage == USAGE_DATA
        }



    },
}
